// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EventTemplate_wrapper__Mi7Ya","description":"EventTemplate_description__HoVcW","content":"EventTemplate_content__7NIEL","sidebar":"EventTemplate_sidebar__2qpgy"};